import * as React from "react";

import { QuestionnaireConsentTabGetDto } from "@common/dto/questionnaire/consent-tab";

import { ConsentProps } from "./consent.types";
import { useConsentController } from "./consent.controller";
import { Header } from "./components/header/header";
import { Page } from "./components/page";

import "./consent.styles.scss";

export const Consent: React.FC<ConsentProps> = (props) => {
  const {
    currentEditingPage,
    handleFieldChange,
  } = useConsentController(props);

  const {
    showConfirmMessage,
    getFields,
    getFolders,
    scrollParentToTop,
    showErrorMessage,
    getFhq4QuestionnaireField,
    errors,
  } = props;

  return (
    <div className="FhqDesignTool-consent">
      <Header
        questionnaire={props.questionnaire}
        onConsentEnable={(enabled) => handleFieldChange({ enabled })}
        onLabelChange={(title) => handleFieldChange({ title })}
        labelValue={currentEditingPage.title}
        consentEnabled={currentEditingPage.enabled}
        errors={errors}
      />

      {currentEditingPage.enabled && (
        <Page
          getFhq4QuestionnaireField={getFhq4QuestionnaireField}
          errors={errors}
          showErrorMessage={showErrorMessage}
          scrollParentToTop={scrollParentToTop}
          getFields={getFields}
          getFolders={getFolders}
          showConfirmMessage={showConfirmMessage}
          cachedData={currentEditingPage as QuestionnaireConsentTabGetDto}
          onChange={handleFieldChange}
        />
      )}
    </div>
  );
};